import React, { memo } from 'react';
import styled from 'styled-components';

import { DailyForecastListItemLoadingUI } from './dailyForecastListItemLoadingUI';
import { smallMediaQuery } from '../../../../common/utilities/sizeHelpers';

export const DailyForecastListLoadingUI = memo(() => {
    return (
        <Container>
            {
                Array.from(Array(10).keys()).map(dayCardIndex => {
                    const isWeekendEnd = dayCardIndex === 6;
                    const isWeekendStart = dayCardIndex === 5;
                    return (
                        <DailyForecastListItemLoadingUI
                            key={`daily-forecast-loading-ui-#${dayCardIndex}`}
                            isWeekendEnd={isWeekendEnd}
                            isWeekendStart={isWeekendStart}
                            dayCardIndex={dayCardIndex} />
                    );
                })
            }
        </Container>
    );
});

const Container = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: auto;
    list-style-type: none;
    padding: 0 48px 0 0;
    height: 600px;
    @media ${smallMediaQuery} {
        width: 100%;
        height: auto;
        margin-right: 0px;
        padding: 0;
        flex-direction: column;
    }
`;